import axios from 'axios'
import store from '../vuex/store';
import router from '../router'
import {
  getCookie,
  removeToken
} from './cookie'
import Cookies from 'js-cookie'
let baseURL = ''
if (process.env.NODE_ENV === 'development') {
  baseURL = process.env.BASE_VUE_STATION
} else {
  baseURL = process.env.BASE_VUE_STATION
}
const service = axios.create({
  baseURL,
  timeout: 10000, // 请求超时时间
  withCredentials: false
})

// request拦截,在请求发起前搞事情
service.interceptors.request.use((config) => {
  if (process.env.NODE_ENV === 'development') {
    config.headers['admin-token'] = getCookie('admin_token');
  }
  config.headers['admin-token'] = getCookie('admin_token')
  return config
})

// respone拦截,获取请求数据后，搞事情
// 这个 request 请求是朱的接口，主要是表单管理的接口
service.interceptors.response.use(
  // 正常获取数据
  response => {
    if (response.data && response.data.code === 200) {
      return response.data
    } else {
      if (response.data.code === 400 && response.data.message) {
        return response.data
      }
      if (response.data.code === 101 || response.data.code === 401) {
        router.push('/login')
        store.commit('app/set_login_dialog_isShow',true)
        return response.data
      }
      console.log(response.data)
        return response.data
    }
  },
  // 请求失败
  error => {
    console.log('请求错误', error)
    return Promise.reject('error', error)
  },
)

export default service



// WEBPACK FOOTER //
// ./src/base/service.js